const MimeTypes = {
  JPEG: 'image/jpeg',
  MP4: 'video/mp4',
  BIN: 'application/octet-stream',
  VIDEOS: 'video/*',
  IMAGES: 'image/*',
};

export default MimeTypes;
